const CARD_ITEMS = [
  {
    title: '深夜密会：顶流男星酒店私会8小时全记录',
    desc: '多方信源交叉印证，大量细节首次披露，吃瓜群众直呼过瘾。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20abstract%20image%20with%20crimson%20accents%2C%20editorial%20style%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-1-91hl&orientation=landscape',
    tag: '最新爆料',
    time: '2小时前',
  },
  {
    title: '学术造假风波：选秀冠军学历遭质疑',
    desc: '知情人提供关键证据，工作室连夜发声明但疑点重重。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20abstract%20editorial%20image%20with%20warm%20crimson%20highlights%2C%20fine%20art%20texture%2C%20mysterious%20tone%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-2-91hl&orientation=landscape',
    tag: '深度追踪',
    time: '5小时前',
  },
  {
    title: '片场大牌风波：当红小花惹怒导演内幕',
    desc: '现场工作人员匿名爆料，还原事件完整经过与后续影响。',
    img: 'https://readdy.ai/api/search-image?query=An%20abstract%20artistic%20composition%20in%20deep%20crimson%20and%20charcoal%2C%20dramatic%20shadows%2C%20editorial%20quality%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-3-91hl&orientation=landscape',
    tag: '现场直击',
    time: '8小时前',
  },
  {
    title: '综艺黑幕：前选手联名举报节目组',
    desc: '五位选手同时发声，揭露选秀节目不为人知的操控机制。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20abstract%20image%20with%20crimson%20red%20tonality%2C%20mysterious%20cinematic%20feel%2C%20artistic%20texture%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-4-91hl&orientation=landscape',
    tag: '独家披露',
    time: '12小时前',
  },
  {
    title: '经纪人恋情：男团成员粉丝集体脱粉',
    desc: '多张亲密照片流出，粉丝后援会宣布暂停应援活动。',
    img: 'https://readdy.ai/api/search-image?query=An%20abstract%20editorial%20composition%20with%20warm%20crimson%20and%20dark%20tones%2C%20dramatic%20atmosphere%2C%20fine%20art%20style%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-5-91hl&orientation=landscape',
    tag: '粉圈震荡',
    time: '1天前',
  },
  {
    title: '偷税风波：大牌代言人连夜被品牌解约',
    desc: '税务部门已介入调查，多个品牌紧急切割关系。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20abstract%20image%20with%20crimson%20highlights%2C%20editorial%20quality%2C%20mysterious%20tone%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-6-91hl&orientation=landscape',
    tag: '突发新闻',
    time: '1天前',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-file-list-3-line text-primary-400 mr-2"></i>
            黑料深扒
          </h2>
          <p className="mt-2 text-sm text-foreground-500">91黑料吃瓜网精选爆料，每一条都值得围观</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARD_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-800/30 border border-background-800/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 4 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500/85 backdrop-blur-sm text-background-950 text-xs font-bold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 rounded-md bg-background-950/70 backdrop-blur-sm text-foreground-400 text-xs">
                    {item.time}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-200 group-hover:text-primary-300 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}